import { PortfolioType } from "../types/stocks-portfolios"

export default defineNuxtRouteMiddleware((to) => {
  const isPortfolioTypeValid = Object.values(PortfolioType).includes(to.params.portfolioType as PortfolioType)

  if (!isPortfolioTypeValid) {
    return navigateTo({ name: "stocks-portfolios", replace: true })
  }
})
